export class SnackbarError extends Error {
  snackbarTitle: string;
  constructor(snackbarTitle: string, message: string) {
    super(message);
    this.name = 'SnackbarError';
    this.snackbarTitle = snackbarTitle;
  }
}
